import { createAction } from '@reduxjs/toolkit';
export const resetTemporarilyExcludedTaskIds = createAction('resetTemporarilyExcludedTaskIds');
export const temporarilyExcludeTaskIds = createAction('temporarilyExcludeTaskIds');